import {
  GET_TAXES,
  GET_TAXES_COMPLETED,
  GET_TAXES_FAILED,
  GET_TAX,
  GET_TAX_COMPLETED,
  GET_TAX_FAILED,
  GET_TAXES_RATES,
  GET_TAXES_RATES_COMPLETED,
  GET_TAXES_RATES_FAILED,
  GET_TAX_RATES,
  GET_TAX_RATES_COMPLETED,
  GET_TAX_RATES_FAILED,
  GET_TAX_GROUPS,
  GET_TAX_GROUPS_COMPLETED,
  GET_TAX_GROUPS_FAILED,
  ADD_TAX,
  ADD_TAX_COMPLETED,
  ADD_TAX_FAILED,
  UPDATE_TAX_RATE,
  UPDATE_TAX_RATE_COMPLETED,
  UPDATE_TAX_RATE_FAILED,
  ADD_TAX_GROUP,
  ADD_TAX_GROUP_COMPLETED,
  ADD_TAX_GROUP_FAILED,
  ADD_TAX_TO_GROUP,
  ADD_TAX_TO_GROUP_COMPLETED,
  ADD_TAX_TO_GROUP_FAILED,
  UPDATE_TAX,
  UPDATE_TAX_COMPLETED,
  UPDATE_TAX_FAILED,
  UPDATE_TAX_GROUP,
  UPDATE_TAX_GROUP_COMPLETED,
  UPDATE_TAX_GROUP_FAILED,
  REMOVE_TAX_FROM_GROUP,
  REMOVE_TAX_FROM_GROUP_COMPLETED,
  REMOVE_TAX_FROM_GROUP_FAILED,
  GET_TAX_GROUP,
  GET_TAX_GROUP_COMPLETED,
  GET_TAX_GROUP_FAILED,
  SEARCH_TAXES, SEARCH_TAXES_COMPLETED, SEARCH_TAXES_FAILED,
  SEARCH_TAX_GROUPS, SEARCH_TAX_GROUPS_COMPLETED, SEARCH_TAX_GROUPS_FAILED,
} from './actions';
import {firstPage} from "../utils/pagination";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  taxesLoading: false,
  taxes: [],
  taxesError: null,
  taxLoading: false,
  tax: null,
  taxError: null,
  addingTax: false,
  updatingTax: false,
  updatingTaxRate: false,
  taxesRatesLoading: false,
  taxesRates: [],
  taxesRatesError: null,
  taxRatesLoading: false,
  taxRates: [],
  taxRatesPagination: firstPage,
  taxRatesError: null,
  taxGroupsLoading: false,
  taxGroups: [],
  taxGroupsError: null,
  addingTaxGroup: false,
  addedTaxGroupId: null,
  addTaxGroupError: null,
  updatingTaxGroup: false,
  removingTaxFromGroup: false,
  gettingTaxGroup: false,
  taxGroup: null,
  addingTaxToGroup: false,
  searchTaxes: searchDefault,
  searchTaxGroups: searchDefault,
};

const taxReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_TAXES: return handleSearch(state, 'searchTaxes', action.payload);
    case SEARCH_TAXES_COMPLETED: return handleSearchCompleted(state, 'searchTaxes', action.payload);
    case SEARCH_TAXES_FAILED: return handleSearchFailed(state, 'searchTaxes', action.payload);
    case SEARCH_TAX_GROUPS: return handleSearch(state, 'searchTaxGroups', action.payload);
    case SEARCH_TAX_GROUPS_COMPLETED: return handleSearchCompleted(state, 'searchTaxGroups', action.payload);
    case SEARCH_TAX_GROUPS_FAILED: return handleSearchFailed(state, 'searchTaxGroups', action.payload);
    case GET_TAXES: {
      return {
        ...state,
        taxesLoading: true,
        taxes: [],
        taxesError: null,
      };
    }
    case GET_TAXES_COMPLETED: {
      return {
        ...state,
        taxesLoading: false,
        taxes: action.payload.data,
      };
    }
    case GET_TAXES_FAILED: {
      return {
        ...state,
        taxesLoading: false,
        taxesError: action.payload,
      };
    }
    case GET_TAX: {
      return {
        ...state,
        taxLoading: true,
        tax: null,
        taxError: null,
      };
    }
    case GET_TAX_COMPLETED: {
      return {
        ...state,
        taxLoading: false,
        tax: action.payload,
      };
    }
    case GET_TAX_FAILED: {
      return {
        ...state,
        taxLoading: false,
        taxError: action.payload,
      };
    }
    case GET_TAXES_RATES: {
      return {
        ...state,
        taxesRatesLoading: true,
        taxesRates: [],
        taxesRatesError: null,
      };
    }
    case GET_TAXES_RATES_COMPLETED: {
      return {
        ...state,
        taxesRatesLoading: false,
        taxesRates: action.payload
      };
    }
    case GET_TAXES_RATES_FAILED: {
      return {
        ...state,
        taxesRatesLoading: false,
        taxesRatesError: action.payload,
      };
    }
    case GET_TAX_RATES: {
      return {
        ...state,
        taxRatesLoading: true,
        taxRates: [],
        taxRatesError: null,
      };
    }
    case GET_TAX_RATES_COMPLETED: {
      return {
        ...state,
        taxRatesLoading: false,
        taxRates: action.payload.data,
      };
    }
    case GET_TAX_RATES_FAILED: {
      return {
        ...state,
        taxRatesLoading: false,
        taxRatesError: action.payload,
      };
    }
    case GET_TAX_GROUPS: {
      return {
        ...state,
        taxGroupsLoading: true,
        taxGroups: [],
        taxGroupsError: null,
      };
    }
    case GET_TAX_GROUPS_COMPLETED: {
      return {
        ...state,
        taxGroupsLoading: false,
        taxGroups: action.payload.data,
      };
    }
    case GET_TAX_GROUPS_FAILED: {
      return {
        ...state,
        taxGroupsLoading: false,
        taxGroupsError: action.payload,
      };
    }
    case ADD_TAX: {
      return {
        ...state,
        addingTax: true,
      };
    }
    case ADD_TAX_COMPLETED: {
      return {
        ...state,
        addingTax: false,
      };
    }
    case ADD_TAX_FAILED: {
      return {
        ...state,
        addingTax: false,
      };
    }
    case UPDATE_TAX_RATE: {
      return {
        ...state,
        updatingTaxRate: true,
      };
    }
    case UPDATE_TAX_RATE_COMPLETED: {
      return {
        ...state,
        updatingTaxRate: false,
      };
    }
    case UPDATE_TAX_RATE_FAILED: {
      return {
        ...state,
        updatingTaxRate: false,
      };
    }
    case ADD_TAX_GROUP: {
      return {
        ...state,
        addingTaxGroup: true,
      };
    }
    case ADD_TAX_GROUP_COMPLETED: {
      return {
        ...state,
        addingTaxGroup: false,
      };
    }
    case ADD_TAX_GROUP_FAILED: {
      return {
        ...state,
        addingTaxGroup: false,
      };
    }
    case ADD_TAX_TO_GROUP: {
      return {
        ...state,
        addingTaxToGroup: true,
      };
    }
    case ADD_TAX_TO_GROUP_COMPLETED: {
      return {
        ...state,
        addingTaxToGroup: false,
      };
    }
    case ADD_TAX_TO_GROUP_FAILED: {
      return {
        ...state,
        addingTaxToGroup: false,
      };
    }
    case UPDATE_TAX: {
      return {
        ...state,
        updatingTax: true,
      };
    }
    case UPDATE_TAX_COMPLETED: {
      return {
        ...state,
        updatingTax: false,
      };
    }
    case UPDATE_TAX_FAILED: {
      return {
        ...state,
        updatingTax: false,
      };
    }
    case UPDATE_TAX_GROUP: {
      return {
        ...state,
        updatingTaxGroup: true,
      };
    }
    case UPDATE_TAX_GROUP_COMPLETED: {
      return {
        ...state,
        updatingTaxGroup: false,
      };
    }
    case UPDATE_TAX_GROUP_FAILED: {
      return {
        ...state,
        updatingTaxGroup: false,
      };
    }
    case REMOVE_TAX_FROM_GROUP: {
      return {
        ...state,
        removingTaxFromGroup: true,
      };
    }
    case REMOVE_TAX_FROM_GROUP_COMPLETED: {
      return {
        ...state,
        removingTaxFromGroup: false,
      };
    }
    case REMOVE_TAX_FROM_GROUP_FAILED: {
      return {
        ...state,
        removingTaxFromGroup: false,
      };
    }
    case GET_TAX_GROUP: {
      return {
        ...state,
        gettingTaxGroup: true,
        taxGroup: null,
      };
    }
    case GET_TAX_GROUP_COMPLETED: {
      return {
        ...state,
        gettingTaxGroup: false,
        taxGroup: action.payload,
      };
    }
    case GET_TAX_GROUP_FAILED: {
      return {
        ...state,
        gettingTaxGroup: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default taxReducer;



// WEBPACK FOOTER //
// ./src/Tax/reducer.js